import { render, staticRenderFns } from "./TipoAnexoField.vue?vue&type=template&id=10d58501&scoped=true&"
import script from "./TipoAnexoField.vue?vue&type=script&lang=js&"
export * from "./TipoAnexoField.vue?vue&type=script&lang=js&"
import style0 from "./TipoAnexoField.vue?vue&type=style&index=0&id=10d58501&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d58501",
  null
  
)

export default component.exports